
































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { ResponseCodeEnum, RoleEnum, TireContractHistory, ChangedItem, TireStoringInfo, TireStoringContractSeasonInfo } from '@/models';
import { tireContractHistoryService, tireStoringContractSeasonInfoService, tireStoringInfoService } from '@/services';

@Component
export default class TireContractHistoryViewer extends Vue {
  @Prop() public contractHistory!: TireContractHistory;
  private tireContractItems: ChangedItem[] = [];
  private tireSeasonInfoItems: ChangedItem[] = [];
  private tireInfoItems: ChangedItem[] = [];

  private tireSeasonInfoData: TireStoringContractSeasonInfo[] = [];
  private tireInfoData: TireStoringInfo[] = [];
  private showCollapse: boolean = false;

  private created() {
    if (this.contractHistory && this.contractHistory.changedItem) {
      this.tireContractItems = this.contractHistory.changedItem.filter((item) => item.itemType && item.itemType.value === 0);
      this.tireSeasonInfoItems = this.contractHistory.changedItem.filter((item) => item.itemType && item.itemType.value === 1);
      this.tireInfoItems = this.contractHistory.changedItem.filter((item) => item.itemType && item.itemType.value === 2);
      const tireSeasonInfoIds = this.tireSeasonInfoItems.map((item) => item.itemId);
      if (tireSeasonInfoIds) {
        this.loadTireSeasonInfoData(tireSeasonInfoIds);
      }
      const tireInfoIds = this.tireInfoItems.map((item) => item.itemId);
      if (tireInfoIds) {
        this.loadTireInfoData(tireInfoIds);
      }
    }
  }

  private loadTireSeasonInfoData(ids: any[]) {
    if (!ids || ids.length === 0) {
      return;
    }
    tireStoringContractSeasonInfoService.getByIds(ids)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireSeasonInfoData = res.data.data.map((tire) => {
            tire.items = this.tireSeasonInfoItems.filter((item) => item.itemId === tire.id);
            return tire;
          });
        }
      });
  }

  private loadTireInfoData(ids: any[]) {
    if (!ids || ids.length === 0) {
      return;
    }
    tireStoringInfoService.getByIds(ids)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireInfoData = res.data.data.map((tire) => {
            tire.items = this.tireInfoItems.filter((item) => item.itemId === tire.id);
            return tire 
          });
        }
      });
  }

  private getBadgeClass(role: string): string {
    if (role === RoleEnum.ROLE_ADMIN || role === RoleEnum.ROLE_USER || role === RoleEnum.ROLE_COMPANY_ADMIN) {
      return 'color-admin';
    } else if (role === RoleEnum.ROLE_WAREHOUSE) {
      return 'color-warehouse';
    } else if (role === RoleEnum.ROLE_AGENCY) {
      return 'color-agency';
    } else if (role === RoleEnum.ROLE_COMPANY) {
      return 'color-company';
    } else if (role === RoleEnum.ROLE_BTJ_COMPANY) {
      return 'color-btj';
    } else {
      return '';
    }
  }

  private getRole(role: string): string {
    if (role === RoleEnum.ROLE_ADMIN || role === RoleEnum.ROLE_COMPANY_ADMIN) {
      return 'roles.admin';
    } else if (role === RoleEnum.ROLE_USER) {
      return 'roles.user';
    } else if (role === RoleEnum.ROLE_WAREHOUSE) {
      return 'roles.warehouse';
    } else if (role === RoleEnum.ROLE_AGENCY) {
      return 'roles.agency';
    } else if (role === RoleEnum.ROLE_COMPANY) {
      return 'roles.company';
    } else if (role === RoleEnum.ROLE_BTJ_COMPANY) {
      return 'roles.btj';
    } else {
      return '';
    }
  }

  private getDateTime(dateTime: number): string {
    return dateTime ? this.$moment(dateTime).format('YYYY-MM-DD HH:mm') : '';
  }

}
